import PropTypes from 'prop-types';
import FJLocalStore from '../../../../store/FJLocalStore';
import styles from './FJModelTagsBadges.module.less';
import { TAGS } from '../../../../constants/FJModelAttributesConstant';

// Import Icons
import QualityIcon from '../../../../assets/svg/modelPanel/quality.svg?react';
import AudioIcon from '../../../../assets/svg/modelPanel/audio.svg?react';
import StartEndIcon from '../../../../assets/svg/modelPanel/start-end.svg?react';
import ShotIcon from '../../../../assets/svg/modelPanel/shot.svg?react';
import TextIcon from '../../../../assets/svg/modelPanel/text.svg?react';
import RefIcon from '../../../../assets/svg/modelPanel/reference.svg?react';
import FastIcon from '../../../../assets/svg/modelPanel/fast.svg?react';
import CinematicIcon from '../../../../assets/svg/modelPanel/cinematic.svg?react';
import ActionSmoothIcon from '../../../../assets/svg/modelPanel/action.svg?react';
import ActionsPrecisionIcon from '../../../../assets/svg/modelPanel/actions-precision.svg?react';
import ExpressionControlIcon from '../../../../assets/svg/modelPanel/expression-control.svg?react';
import classNames from 'classnames';

// Mapping from feature string to UI config (text and icon)
const FEATURE_CONFIG = {
    // Video features
    [TAGS.P720]: { text: '720p', icon: QualityIcon },
    [TAGS.P768]: { text: '768p', icon: QualityIcon },
    [TAGS.P1080]: { text: '1080p', icon: QualityIcon },
    [TAGS.AUDIO]: { text: 'dubbing', icon: AudioIcon },
    [TAGS.KEYFRAMES]: { text: 'keyframes', icon: StartEndIcon },
    [TAGS.SHOTS]: { text: 'shots', icon: ShotIcon },
    [TAGS.TEXT_PROMPT]: { text: 'text-prompt', icon: TextIcon },
    [TAGS.REFERENCE]: { text: 'reference', icon: RefIcon },
    [TAGS.FAST]: { text: 'fast-model-tag', icon: FastIcon },
    [TAGS.CINEMATIC]: { text: 'cinematic-model-tag', icon: CinematicIcon },
    [TAGS.ACTION_SMOOTH]: { text: 'action-smooth', icon: ActionSmoothIcon },
    [TAGS.ACTIONS_PRECISION]: { text: 'actions-precision', icon: ActionsPrecisionIcon },
    [TAGS.EXPRESSION_CONTROL]: { text: 'expression-control', icon: ExpressionControlIcon },
    // Image features (reusing some icons)
    [TAGS.K2]: { text: '2k', icon: QualityIcon },
    [TAGS.K4]: { text: '4k', icon: QualityIcon },
};

const FJModelTagsBadges = ({ features, badgeItemClass }) => {
    if (!features || features.length === 0) return null;

    return (
        <div className={styles.badges_container}>
            {features.map((feature, index) => {
                const config = FEATURE_CONFIG[feature];
                if (!config) return null;

                const Icon = config.icon;

                return (
                    <div key={index} className={classNames(styles.badge, badgeItemClass)}>
                        {Icon && <Icon className={styles.badge_icon} />}
                        <span className={styles.badge_text}>{FJLocalStore._(config.text)}</span>
                    </div>
                );
            })}
        </div>
    );
};

FJModelTagsBadges.propTypes = {
    features: PropTypes.arrayOf(PropTypes.string),
    badgeItemClass: PropTypes.string,
};

export default FJModelTagsBadges;
